import { render, staticRenderFns } from "./ProjectsByTypes.vue?vue&type=template&id=b29d030e"
import script from "./ProjectsByTypes.vue?vue&type=script&lang=js"
export * from "./ProjectsByTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports